const steps = [
  "Boottype",
  "Bootgegevens",
  "Waarborgen",
  "Persoonlijke Gegevens",
  "Bevestiging",
];

export default steps;
